import React from "react";
import PythonDiagram from "components/Diagrams/PythonDiagram";

function ProgrammingPageView({ languageName, substructureName, finalStages = [], items = [] }) {

  const LANGUAGE_MAP = {
    Python: (
      <PythonDiagram
        finalStages={finalStages}
        items={items}
        substructureName={substructureName}
      />
    ),
  };

  const diagram = LANGUAGE_MAP[languageName];

  if (!diagram) {
    return (
      <p style={{
        color: "white",
        fontSize: "1rem",
        fontFamily: "Poppins, sans-serif",
        textAlign: "center",
        padding: "1.5rem",
        background: "rgba(255, 255, 255, 0.05)",
        borderRadius: "0.75rem",
        border: "1px solid rgba(255, 255, 255, 0.1)",
      }}>
        Γλώσσα "{languageName}" δεν υποστηρίζεται ακόμα.
      </p>
    );
  }

  return diagram;
}

export default ProgrammingPageView;